import {
	apuracaoSummaryCards,
	apuracaoHistorySummaryCards
} from "../config/apuracao-summary-cards-config";

export const buildApprovalSummaryCards = statistics => {
	const totalsByKey = {
		"open-installments":
			statistics?.valorTotalParcelasEmAberto,
		"granted-discounts":
			statistics?.valorTotalDescontoConcedidos,
		"amount-receivable":
			statistics?.valorTotalAposDescontos
	};

	return apuracaoSummaryCards.map(card => ({
		...card,
		monthValue: totalsByKey[card.key]?.mes ?? 0,
		quarterValue: totalsByKey[card.key]?.trimestre ?? 0
	}));
};

export const buildHistorySummaryCards = statistics => {
	const totalsByKey = {
		"assessed-installments":
			statistics?.totalParcelasApuradas,
		"granted-discounts-history":
			statistics?.totalDescontoConcedido,
		"received-after-discounts":
			statistics?.totalRecebidoPosDesconto
	};

	return apuracaoHistorySummaryCards.map(card => ({
		...card,
		value: totalsByKey[card.key] ?? 0
	}));
};

export const buildClientSizeOptions = (segmentations = []) => {
	return segmentations
		.filter(item => item.segmentation)
		.map(item => ({
			label: item.segmentation,
			value: item.segmentation
		}));
};

export const withClientSizeOptions = (
	config,
	options,
	disabled = false
) => {
	return config.map(section => ({
		...section,
		fields: section.fields.map(field => {
			if (field.name !== "clientSize") {
				return field;
			}

			return {
				...field,
				options,
				disabled
			};
		})
	}));
};

export const getStatusLabel = value => {
	if (value === null || value === undefined) {
		return "-";
	}

	if (typeof value !== "boolean") {
		return value;
	}

	return value ? "Sim" : "Não";
};

export const getAssessmentStatus = status => {
	switch (status) {
		case "APROVADO":
			return { label: "Aprovado", variant: "approved" };

		case "REPROVADO":
			return { label: "Reprovado", variant: "rejected" };

		case "APURADO":
			return { label: "Apurado", variant: "neutral" };

		case "PREVIA":
			return { label: "Prévia", variant: "neutral" };

		default:
			return { label: "-", variant: "neutral" };
	}
};